export const GLOSSARY_SEED = [
  {
    "term": "Bearing Plates",
    "definition": "A steel plate that mounts on the wall above the Horizontal Track that has a hole and a bearing in which the torsion bar slips through."
  },
  {
    "term": "BMTS",
    "definition": "Bracket Mount Track Set."
  },
  {
    "term": "Bottom Fixture",
    "definition": "A steel bracket that mounts on the bottom outside edges of the door. The cables attach to this fixture and allow the counterbalance assembly to lift the door."
  },
  {
    "term": "Cables",
    "definition": "A stranded wire that connects the Counterbalance assembly allowing it to lift the door."
  },
  {
    "term": "Cable Drum",
    "definition": "A grooved spool that rolls up the cable to lift the door."
  },
  {
    "term": "Casing",
    "definition": "Typically wood 2x6 boards that are mounted flat as a border around the inside of the door opening. The door track is mounted onto this casing."
  },
  {
    "term": "Center Mount",
    "definition": "This is where the universal spring mount attaches to the wall above the counterbalance assembly."
  },
  {
    "term": "Common",
    "definition": "The neutral wire in an AC power pair. Typically the white wire."
  },
  {
    "term": "CounterBalance Assembly",
    "definition": "The spring system that is wound up to create tension in order to lift the door. (Spring Assembly or Torsion Assembly)",
    "aliases": [
      "Spring Assembly",
      "Torsion Assembly"
    ]
  },
  {
    "term": "CTM",
    "definition": "Cable Tension Monitor."
  },
  {
    "term": "Door Lift Type",
    "definition": "Every garage door has a Lift Type that is determined by the amount of Headroom available. Standard Lift is the default lift type. Low Headroom Lift is for less than ideal amount of Headroom. High Lift is an option lift type when much more headroom than is needed is present."
  },
  {
    "term": "Double End Style",
    "definition": "A description of a door section that has an endcap that is the width of two hinges and includes two hinges on either side of the section."
  },
  {
    "term": "Door Sensors",
    "definition": "See Safety Sensors.",
    "aliasOf": "Safety Sensors"
  },
  {
    "term": "End Cap",
    "definition": "The metal cap on each end of a door section."
  },
  {
    "term": "Entrapment Protection",
    "definition": "A system that includes Safety Sensors or some other means of detecting the presence of something or someone under the door, so that it does not travel downward and either become damaged or cause harm to someone or something."
  },
  {
    "term": "Extension Spring",
    "definition": "A thin wired bouncy spring with hooks on each end that uses cables, pulleys and spring tension to assist the user to open the door."
  },
  {
    "term": "Eyes",
    "definition": "See Safety Sensors.",
    "aliasOf": "Safety Sensors"
  },
  {
    "term": "Finished Opening",
    "definition": "Finished trim wraps the door opening typically reducing the door opening by about 1 - 2 inches wide and 1 inch high."
  },
  {
    "term": "Flag Bracket",
    "definition": "A wall mount bracket that secures the track to the wall, joins the vertical and horizontal track together, as well as aligns both tracks so the rollers run through them smoothly."
  },
  {
    "term": "Headroom",
    "definition": "The amount of wall space between the top of the door opening and the ceiling. The door lift type is directly affected by the amount of headroom. Standard lift Residential doors call for 15 inches of Headroom and Standard lift Commercial Doors call for 18 inches of Headroom."
  },
  {
    "term": "High Lift",
    "definition": "(see figure 3.0) Door sites that have much more headroom than is needed have the option of employing a High Lift Track. A High Lift includes a section of track, called a UHA, that extends the vertical movement of the door towards the ceiling before the horizontal track is involved. The main purpose of a High Lift is to lift the door hardware up as close to the ceiling as possible."
  },
  {
    "term": "High Voltage",
    "definition": "110 volt electrical wiring installed by a licensed electrician."
  },
  {
    "term": "Hinge",
    "definition": "Hinges that connect each section of a door together. They range from #1 - #12 hinges and beyond."
  },
  {
    "term": "Hoist Opener",
    "definition": "An electric Jackshaft operator that also includes a manual chain hoist for raising the door by hand."
  },
  {
    "term": "Horizontal Track",
    "definition": "The portion of the door roller track that runs parallel to the ceiling. On a Standard Lift it typically includes a radius or curve section. The standard radius is 15 inches. Other radii include 12 inches and 10 inches. Low headroom track is a modified horizontal track that has 2 curved tracks that run mostly side by side."
  },
  {
    "term": "Jackshaft Opener",
    "definition": "A wall mount operator that connects to the torsion shaft directly or indirectly via a sprocket and chain. The opener raises and lowers the door by rotating the shaft. There is no physical connection between the opener and the door and therefore the opener relies on gravity to lower the door to the floor."
  },
  {
    "term": "Jambs",
    "definition": "See Casing.",
    "aliasOf": "Casing"
  },
  {
    "term": "Keypad",
    "definition": "See Wireless Keypad.",
    "aliasOf": "Wireless Keypad"
  },
  {
    "term": "Lift Type",
    "definition": "A track configuration that accommodates the amount of headroom a door site has. Garage door lift types will most likely be one of the following: Standard Lift, Low Headroom, High Lift, Vertical Lift, or Inclined Track. (See each term for more details)"
  },
  {
    "term": "Lites",
    "definition": "Windows of some kind that are built into the door."
  },
  {
    "term": "LMEP",
    "definition": "LiftMaster Edge Protection. See Safety Sensors.",
    "aliases": [
      "LiftMaster Edge Protection"
    ]
  },
  {
    "term": "Low Headroom",
    "definition": "A door site that has less than ideal space on the wall above the door opening. For Residential doors less than 12 inches would be considered Low Headroom. For commercial doors less than 15 inches would be considered Low Headroom. A special track called a Low Overhead Track is needed to accommodate this issue."
  },
  {
    "term": "Low Headroom Track",
    "definition": "(see figure 2.0) A special horizontal track that is made up of 2 courses of track that isolates the very top roller in the upper most track causing the top section to move away from the door-wall rapidly so that it won't contact the ceiling or counterbalance assembly."
  },
  {
    "term": "Low Voltage",
    "definition": "Wiring that is used mostly for communication transmission between a brain unit and its external sensors. Garage door operators receive a signal from safety sensors and from a wall station for normal operation. Another common application of low voltage is in the operation of a thermostat connected to a boiler or heat exchanger."
  },
  {
    "term": "MAS",
    "definition": "Maintenance Alert System."
  },
  {
    "term": "My Q",
    "definition": "A wifi based application put out by LiftMaster which allows users to control their LiftMaster openers and to be notified when devices are active."
  },
  {
    "term": "Nylon Bushing",
    "definition": "A nylon spacer that is placed on the torsion shaft in order to keep the shaft and the springs centered and in alignment. (Vs a Steel Bearing Bushing)"
  },
  {
    "term": "Opener",
    "definition": "Electric motor that lifts and lowers the door by some mechanical method."
  },
  {
    "term": "Overhead Opener",
    "definition": "See Trolley Opener.",
    "aliasOf": "Trolley Opener"
  },
  {
    "term": "Operator",
    "definition": "See Opener.",
    "aliasOf": "Opener"
  },
  {
    "term": "Panel",
    "definition": "See Section.",
    "aliasOf": "Section"
  },
  {
    "term": "Rail",
    "definition": "Typically an I-beam that runs from the Trolley Opener to the wall above the door. A Chain or Belt runs around the rail and drives the door up and down."
  },
  {
    "term": "Remote",
    "definition": "A wireless controller for the opener that communicates with the opener via a radio frequency signal."
  },
  {
    "term": "Rough Opening",
    "definition": "The framed door opening which should be equal to the exact width and height of the stacked door sections."
  },
  {
    "term": "Safety Sensors",
    "definition": "A part of an opener's Entrapment Protection System. These Safety Sensors are placed at the bottom of the door to detect if something or someone is in the way of the door being closed completely.",
    "aliases": [
      "Door Sensors",
      "Eyes",
      "Sensor"
    ]
  },
  {
    "term": "Section",
    "definition": "A piece of the actual door typically the width of the door by either 18 inches, 21 inches, or 24 inches tall."
  },
  {
    "term": "Sensor",
    "definition": "See Safety Sensors.",
    "aliasOf": "Safety Sensors"
  },
  {
    "term": "Single End Style",
    "definition": "A description of a door section that has a standard size end cap and a single hinge on either side of the section."
  },
  {
    "term": "Sprocket",
    "definition": "A star shaped wheel with teeth that work with a chain to rotate a shaft or other item. Commonly seen on bicycles."
  },
  {
    "term": "Standard Lift",
    "definition": "(see figure 1.0) The default lift type of a garage door. For doors that have the ideal amount of headroom. Horizontal track standardly includes a 15 inch radius but can be ordered in 12 inch and sometimes 10 inch radius."
  },
  {
    "term": "Steel Bearing Bushing",
    "definition": "A steel spacer with a bearing that is placed on the torsion shaft in order to keep the shaft and the springs centered and in alignment. (Vs a Nylon Bushing)"
  },
  {
    "term": "Strut",
    "definition": "A steel reinforcement to prevent the door from flexing or sagging while the door travels up and down or sits open."
  },
  {
    "term": "Tek Screws",
    "definition": "The self tapping fasteners that the install technician uses to install the parts on the door."
  },
  {
    "term": "Top Fixture",
    "definition": "The adjustable bracket located on the top section of the garage door which sets the tolerance for how tight the top of the door seals to the wall. Commonly it has a triangular shape."
  },
  {
    "term": "Track",
    "definition": "The metal channel on either side of the door in which the rollers ride. The track guides the door up and down the wall. It is made up of two basic types of track: Vertical Track and Horizontal Track. Additional types include Upper High-Lift Assembly (See UHA), Vertical Assembly, Low Headroom and Zero Clearance."
  },
  {
    "term": "Trim",
    "definition": "The finish covering for the framing of the door opening. The most common trim for finishing a door opening is wood of some sort, such as 5/4 Smart Trim. Other trim options include 3/4 cedar and metal wrap. The thickness of the trim can affect what the rough opening size should be."
  },
  {
    "term": "Trolley Opener",
    "definition": "Also referred to as Overhead Openers, these garage door openers are located on the ceiling at the center of the door. The Opener rail includes a small latch, called a Trolley, on a chain or belt that runs back and forth to raise or lower the door. Trolley openers have a direct connection to the door, pulling it open and pushing it closed. Trolley openers do not typically have problems with cables tangling.",
    "aliases": [
      "Overhead Opener"
    ]
  },
  {
    "term": "Torsion Bar",
    "definition": "(Shaft) At the core of the CounterBalance assembly, the Torsion Bar runs through the torsion springs and the cable drums to keep them rotating in unison.",
    "aliases": [
      "Torsion Shaft",
      "Shaft"
    ]
  },
  {
    "term": "Torsion Spring",
    "definition": "The most common type of garage door spring is a Torsion spring, which is threaded onto the torsion bar. This type of spring is wound up to create torsion that does the work to lift the door on the way up, but when engineered correctly for a door the weight of the door will overpower the spring when it is on its way down thereby re-winding the spring making it ready to lift open again when it is time. The Torsion spring therefore is what does the work of lifting the door rather than the opener, which is only supposed to guide the door up and down."
  },
  {
    "term": "UHA",
    "definition": "Short for Upper High-Lift Assembly. This is a section of track that extends the vertical travel of the door. Its purpose is to bring the door and its hardware closer to the ceiling to keep it out of the way.",
    "aliases": [
      "Upper High-Lift Assembly"
    ]
  },
  {
    "term": "Universal Mount",
    "definition": "A mounting bracket connecting the Torsion Springs to the wall. This bracket is universal in that it has a range of locations that the springs can mount to so they can be set in alignment with the rest of the Counterbalance assembly."
  },
  {
    "term": "Vertical Lift",
    "definition": "(see figure 4.0) A track configuration that lifts the door exclusively in a vertical direction. A vertical lift track configuration requires a ceiling height that is more than double the height of the door."
  },
  {
    "term": "Vertical Track",
    "definition": "The portion of the door roller track that runs mostly parallel to the door wall. On a Standard Lift it typically is 8 inches shorter than the door height. From that point the Horizontal track takes over."
  },
  {
    "term": "Wall Controller",
    "definition": "A controller for the opener that mounts on the wall, typically nearest the entrance to the garage from the home or office. Every opener should include only one (low voltage) wired wall controller. Additional wireless controllers can be added as remotes to control the opener."
  },
  {
    "term": "Wireless Keypad",
    "definition": "An exterior opener remote that requires a passcode to control the garage door opener. Typically mounted on the face of the door opening trim wrap.",
    "aliases": [
      "Keypad"
    ]
  },
  {
    "term": "Inclined Track",
    "definition": "(Definition pending — referenced by Lift Type and Track. Add the full definition here.)",
    "stub": true
  }
];
